import { ICONOS, type NombreIcono } from './iconos';

interface IconProps {
  /** Nombre del icono en el catálogo (`src/presentation/components/ui/iconos.ts`). */
  nombre: NombreIcono;
  /** Tamaño en píxeles. */
  tamano?: number;
  color?: string;
  className?: string;
  /**
   * Texto para lectores de pantalla.
   * Si se omite, el icono se marca como decorativo: es lo correcto cuando va
   * junto a una etiqueta visible que ya dice lo mismo.
   */
  etiqueta?: string;
}

/**
 * Icono del sistema.
 *
 * El nombre está tipado contra el catálogo, así que escribir uno inexistente
 * es un error de compilación.
 *
 * Aun así se comprueba en tiempo de ejecución: hay iconos que vienen de la
 * base de datos —el de un punto de interés, por ejemplo— y ahí el tipo es una
 * promesa, no una garantía. Un nombre guardado hace dos años, o escrito por
 * otra aplicación, dejaba `Svg` en `undefined` y React tumbaba la pantalla
 * entera con un «element type is invalid». Un icono que no se reconoce no es
 * motivo para perder la pantalla: se dibuja el genérico y se sigue.
 */
export function Icon({ nombre, tamano = 20, color, className, etiqueta }: IconProps) {
  const Svg = ICONOS[nombre] ?? ICONOS.circulo;

  return (
    <Svg
      width={tamano}
      height={tamano}
      className={className}
      style={{ color, flexShrink: 0, display: 'block' }}
      aria-hidden={etiqueta ? undefined : true}
      aria-label={etiqueta}
      role={etiqueta ? 'img' : undefined}
    />
  );
}

export type { NombreIcono };
